// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "单片机原理及应用",
        "tec": "雷彦华",
        "week": "1-8单周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "雷彦华",
        "week": "15周",
        "add": "实训楼F座203自控"
      }
    ],
    [
      {
        "sub": "计算机控制系统",
        "tec": "年佳琪",
        "week": "1-8周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "雷彦华",
        "week": "15周",
        "add": "实训楼F座203自控"
      }
    ],
    [
      {
        "sub": "传感器技术",
        "tec": "刘慧洁",
        "week": "1-8周",
        "add": "教学楼A座217电力"
      },
      {
        "sub": "传感器技术",
        "tec": "刘慧洁",
        "week": "9-12周",
        "add": "教学楼A座217电力"
      }
    ],
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李进",
        "week": "1-8周",
        "add": "教学楼A座322电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "李进",
        "week": "9-12周",
        "add": "教学楼A座322电力"
      }
    ],
    0
  ],
  "2": [
    [
      {
        "sub": "Python程序设计",
        "tec": "刘炜",
        "week": "5-12周",
        "add": "教学楼B座124自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "雷彦华",
        "week": "15周",
        "add": "实训楼F座203自控"
      }
    ],
    [
      {
        "sub": "DSP原理及应用",
        "tec": "年佳琪",
        "week": "5-12周",
        "add": "教学楼B座121自控"
      },
      {
        "sub": "劳动与创造",
        "tec": "雷彦华",
        "week": "15周",
        "add": "实训楼F座203自控"
      }
    ],
    0,
    {
      "sub": "就业创业指导",
      "tec": "许文利陈晓红",
      "week": "1-5周",
      "add": "实训楼F座102自控"
    },
    0
  ],
  "3": [
    {
      "sub": "传感器技术",
      "tec": "刘慧洁",
      "week": "1-8单周",
      "add": "实训楼F座103自控"
    },
    [
      {
        "sub": "单片机原理及应用",
        "tec": "雷彦华",
        "week": "1-8周",
        "add": "实训楼F座302信息"
      },
      {
        "sub": "单片机原理及应用",
        "tec": "雷彦华",
        "week": "9-12周",
        "add": "实训楼F座302信息"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "DSP原理及应用",
      "tec": "年佳琪",
      "week": "5-12周",
      "add": "实训楼F座303信息"
    },
    {
      "sub": "Python程序设计",
      "tec": "刘炜",
      "week": "5-12周",
      "add": "实训楼F座401信息"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李进",
        "week": "1-8周",
        "add": "教学楼A座321电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "李进",
        "week": "9-12周",
        "add": "教学楼A座321电力"
      }
    ],
    0,
    0
  ],
  "5": [
    {
      "sub": "计算机控制系统",
      "tec": "年佳琪",
      "week": "1-8周",
      "add": "教学楼B座218自控"
    },
    [
      {
        "sub": "传感器技术",
        "tec": "刘慧洁",
        "week": "1-8周",
        "add": "教学楼C座302教务"
      },
      {
        "sub": "传感器技术",
        "tec": "刘慧洁",
        "week": "9-12周",
        "add": "教学楼C座302教务"
      }
    ],
    [
      {
        "sub": "单片机原理及应用",
        "tec": "雷彦华",
        "week": "1-8周",
        "add": "实训楼F座102自控"
      },
      {
        "sub": "单片机原理及应用",
        "tec": "雷彦华",
        "week": "9-12周",
        "add": "实训楼F座102自控"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
